import { Input, Injector } from "@angular/core";
import { DiagnosedItem } from "../../../dataModels/diagnosed-item";

export abstract class ChildParentAbstractTalk extends DiagnosedItem {

    @Input() localizationSource: string;
    @Input() width: string;
    @Input() inputWidth: number;
    @Input() type: string;
    @Input() isInline: boolean;

    public abstract tellYourParents();

    constructor(protected injector: Injector) {
        super(injector);
    }
}

export abstract class ChildParentTalk extends ChildParentAbstractTalk {

    abstract get familyId(): string;

    constructor(protected injector: Injector) {
        super(injector);
    }

    public takeChild(child: ChildParentTalk) {
        child.localizationSource = child.localizationSource || this.localizationSource;
        child.width = child.width || this.width;
        child.inputWidth = child.inputWidth || this.inputWidth;
        child.type = child.type || this.type;
        if (child.isInline !== true && child.isInline !== false) {
            child.isInline = this.isInline;
        }
    }
}

export interface IErrorHandler {
    isError: boolean;
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/data-models/child-parent-talk.ts